import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const AlertContainer = styled.div`
  width: 100%;
  border: 1px solid ${prop => prop.border};
  background: ${prop => prop.background};
  padding: 16px;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  display: grid;
  grid-template-columns: 50px 1fr;
  align-items: center;
  color: ${colors.textPrimary};
  border-radius: 8px;
`;

export const AlertIcon = styled.div`
  width: 32px;
  height: 32px;
  background: ${prop => prop.background};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  margin-right: 16px;
`;
